const AIDEXA_PIVA = '00691500706';
const CROSS_ONBOARDING_PIVA = '11754740121';
const NEW_EXPIRATION_DATE_INITIAL_DATE = new Date('2022-09-18');
const TODAY = Date.now();

export const BANK_ACCOUNT_PRODUCTS = ['X Conto Base', 'X Conto Plus'] as const;

export { AIDEXA_PIVA, CROSS_ONBOARDING_PIVA, NEW_EXPIRATION_DATE_INITIAL_DATE, TODAY };
